'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostponeBasket = undefined;

var _PostponeBasket2 = require('./PostponeBasket');

var _PostponeBasket3 = _interopRequireDefault(_PostponeBasket2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PostponeBasket = _PostponeBasket3.default; /**
                                                    * Created by maximus on 16.12.16.
                                                    */


//////////////////
// WEBPACK FOOTER
// ./src/containers/PostponeBasket/index.js
// module id = 1841
// module chunks = 0